module.exports = {
  siteMetadata: {
    title: `Code Sculpture: Create 3D art from simple rules (from James Porter)`
  },
  plugins: [
    `gatsby-plugin-react-helmet`,
    `gatsby-plugin-react-next`,
    `gatsby-plugin-typescript`
  ]
};



// WEBPACK FOOTER //
// ./gatsby-config.js